function randomIpfsHost() {
  const hosts = [
    'https://ipfs.io/ipfs/',
    // 'https://permaweb.eu.org/ipfs/',
    // 'https://gateway.ipfs.io/ipfs/',
    'https://cloudflare-ipfs.com/ipfs/',
    'https://lico.mypinata.cloud/ipfs/',
    'https://lico.mypinata.cloud/ipfs/',
    // 'https://ravencoinipfs-gateway.com/ipfs/',
    'https://gateway.pinata.cloud/ipfs/',
  ]
  const random = Math.floor(Math.random() * hosts.length)
  return hosts[random]
}

export function parseUrl(url: string) {
  if (url.startsWith('ipfs://')) {
    return url.replace('ipfs://', randomIpfsHost())
  }
  if (url.startsWith('https://ipfs.io/ipfs/')) {
    return url.replace('https://ipfs.io/ipfs/', randomIpfsHost())
  }
  if (url.startsWith('https://gateway.pinata.cloud/ipfs/')) {
    return url.replace('https://gateway.pinata.cloud/ipfs/', randomIpfsHost())
  }
  return url
}
